import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StoreModel } from 'src/graphql/generated/graphql';
import { Card, Tabs } from '@otp/ui';
import { RestaurantCard } from './restaurant-card';
import { OTPsAssignedList } from './otps/otps-assigned-list';
import { OTPsUnassignedList } from './otps/otps-unassigned-list';
import { RestaurantMap } from './map';
import { RestaurantInfo } from './restaurant-info';
import { RestaurantActions } from './restaurant-actions';
import { RestaurantNeedAttentionReasons } from './restaurant-need-attention-reasons';
import { ContentWrapper } from 'src/components/common/wrapper/content/wrapper';
import { RestaurantIssues } from './restaurant-issues';
import { RestaurantWttp } from './restaurant-wttp';
import { useDeviceContext } from 'src/context/device.context';
import clsx from 'clsx';

type RestaurantDetailsProps = {
  store: Partial<StoreModel>;
};

enum TabType {
  OTPs = 'otps',
  Details = 'details',
  Wttp = 'wttp',
  Issues = 'issues',
  Actions = 'actions',
}

export const RestaurantDetails = ({ store }: RestaurantDetailsProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'manage-restaurants.tabs',
  });
  const { isMobile } = useDeviceContext();
  const [activeTab, setActiveTab] = useState(TabType.OTPs);
  if (!isMobile && activeTab == TabType.Actions) {
    setActiveTab(TabType.OTPs);
  }
  const TABS = !isMobile
    ? [
        { label: t('otps'), value: TabType.OTPs },
        { label: t('details'), value: TabType.Details },
        { label: t('wttp'), value: TabType.Wttp },
        { label: t('issues'), value: TabType.Issues },
      ]
    : [
        { label: t('otps'), value: TabType.OTPs },
        { label: t('details'), value: TabType.Details },
        { label: t('actions'), value: TabType.Actions },
        { label: t('wttp'), value: TabType.Wttp },
        { label: t('issues'), value: TabType.Issues },
      ];

  return (
    <ContentWrapper>
      <Card
        noBorder
        className="grid md:grid-cols-12 grid-cols-1 bg-white flex md:flex-row grow gap-6 w-full"
      >
        <div
          className={clsx(
            'flex flex-col grow items-center lg:col-span-3',
            !isMobile ? 'col-span-4' : '',
          )}
        >
          <RestaurantCard store={store} />
          {!isMobile && <RestaurantActions store={store} />}
        </div>
        <div
          className={clsx(
            'flex flex-col grow gap-6  lg:col-span-9',
            !isMobile ? 'col-span-8' : '',
          )}
        >
          <Tabs
            tabs={TABS}
            onChange={(_, value) => setActiveTab(value)}
            value={activeTab}
          />
          {activeTab === TabType.OTPs && (
            <>
              <RestaurantNeedAttentionReasons store={store} />
              <OTPsAssignedList store={store} />
              <OTPsUnassignedList store={store} />
            </>
          )}
          {activeTab === TabType.Details && (
            <>
              <RestaurantInfo store={store} />
              <RestaurantMap store={store} />
            </>
          )}
          {activeTab === TabType.Issues && <RestaurantIssues store={store} />}
          {activeTab === TabType.Wttp && <RestaurantWttp store={store} />}
          {activeTab === TabType.Actions && <RestaurantActions store={store} />}
        </div>
      </Card>
    </ContentWrapper>
  );
};
